module.exports = __webpack_public_path__ + "static/media/warning.5794f6ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/MemberProfile/warning.svg
// module id = 367
// module chunks = 0